import { Pricing } from '@seatsio/seatsio-react';
import { Ticket } from 'types/TicketsState';
import {
  applyDiscountToPrice,
  getFeePrice,
  getTaxPrice,
  roundUpDecimals,
} from './tickets';
import { EventFeesData, ITaxRate } from 'app/pages/TicketSalePage/slice/types';
import { VoucherApplicableTickets } from 'types/CartItem';

export const formatTicketsPricingForSeatingChart = (
  tickets: Ticket[],
  tax_included: boolean,
  fee_included: boolean,
  fees: EventFeesData,
  tax_rate: ITaxRate,
  voucherApplicableTickets: VoucherApplicableTickets,
  discount: number,
  discount_percent: boolean,
): Pricing =>
  tickets.map(({ id, seatsCategoryKey, ticketprice, subtypes }) => {
    if (subtypes?.length) {
      return {
        category: seatsCategoryKey,
        ticketTypes: subtypes.map(({ id, name, price }) => {
          let totalPrice = price;

          if (tax_included) {
            const theTaxPaidForASingleTicket = getTaxPrice(
              price,
              tax_rate.rate,
            );
            totalPrice += theTaxPaidForASingleTicket;
          }

          if (fee_included) {
            const theFeePaidForASingleTicket = getFeePrice(
              firstTicketOption?.price,
              fees,
            );
            totalPrice += theFeePaidForASingleTicket;
          }

          if (voucherApplicableTickets.findIndex(el => el === id) >= 0) {
            totalPrice = applyDiscountToPrice(
              totalPrice,
              discount,
              discount_percent,
            );
          }

          return {
            ticketType: id,
            label: name,
            price: totalPrice,
          };
        }),
      };
    }

    const firstTicketOption = ticketprice[0];
    let price = firstTicketOption?.price;

    if (tax_included) {
      const theTaxPaidForASingleTicket = getTaxPrice(
        firstTicketOption?.price,
        tax_rate.rate,
      );
      price += theTaxPaidForASingleTicket;
    }

    if (fee_included) {
      const theFeePaidForASingleTicket = getFeePrice(
        firstTicketOption?.price,
        fees,
      );
      price += theFeePaidForASingleTicket;
    }

    if (voucherApplicableTickets.findIndex(el => el === id) >= 0) {
      price = applyDiscountToPrice(price, discount, discount_percent);
    }

    return {
      category: seatsCategoryKey,
      price: roundUpDecimals(price),
    };
  });
